module.exports = __webpack_public_path__ + "static/img/davis_pictgrid21_960x850.21d12c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid21_960x850.jpg
// module id = fW9X
// module chunks = 0